export const inr = (n) => {
  const v = Number(n || 0);
  return "₹" + v.toLocaleString("en-IN", { maximumFractionDigits: 2 });
};

export const inrCompact = (n) => {
  const v = Number(n || 0);
  if (Math.abs(v) >= 1e7) return "₹" + (v / 1e7).toFixed(2) + " Cr";
  if (Math.abs(v) >= 1e5) return "₹" + (v / 1e5).toFixed(2) + " L";
  if (Math.abs(v) >= 1e3) return "₹" + (v / 1e3).toFixed(1) + "K";
  return "₹" + v.toLocaleString("en-IN");
};

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
};

export const fmtDateTime = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return s;
  }
};

export const ROLE_LABEL = (role) => ({
  super_admin: "Admin", admin: "Admin",
  loan_backend: "Backend Executive", own_brand_sales: "OB Sales Executive",
  team_leader: "Team Leader", tellecaller: "Tellecaller",
  accounts: "Accounts", hr: "HR", agent: "Agent", own_brand_partner: "Own Brand Partner",
  pending: "Pending",
}[role] || role || "—");

// Client mirror of backend commission engine
export const computeCommission = (d) => {
  const loan = Number(d.loan_amount || 0);
  const gross = d.commission_type === "flat"
    ? Number(d.commission_flat || 0)
    : (loan * Number(d.commission_percent || 0)) / 100;
  const gst = (gross * Number(d.gst_percent || 0)) / 100;
  const tds = (gross * Number(d.tds_percent || 0)) / 100;
  const aca = Number(d.agent_commission_amount || 0);
  const pct = Number(d.agent_share_percent || 0);
  const agent = pct > 0 ? (loan * pct) / 100 : aca;
  const other = Number(d.other_deductions || 0);
  const net = gross - tds + gst - agent - other;
  const agentTds = (agent * Number(d.tds_percent || 0)) / 100;
  const agentGst = d.agent_has_gst ? (agent * Number(d.gst_percent || 0)) / 100 : 0;
  const agentNet = agent - agentTds + agentGst;
  const r = (x) => Math.round(x * 100) / 100;
  return {
    gross_commission: r(gross), gst_amount: r(gst), tds_amount: r(tds),
    agent_commission: r(agent), net_company_commission: r(net), other_deductions: r(other),
    agent_tds_amount: r(agentTds), agent_gst_amount: r(agentGst), agent_net_commission: r(agentNet),
  };
};
